<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="用户名"
                  readonly
                  v-model="item.username"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="密码"
                  type="password"
                  required
                  :rules="rules.password"
                  v-model="item.password"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="密码确认"
                  type="password"
                  required
                  :rules="rules.rePassword"
                  v-model="item.rePassword"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="电子邮箱"
                  :rules="rules.email"
                  v-model="item.email"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="联系电话"
                  :rules="rules.phone"
                  v-model="item.phone"
                />
              </v-flex>
              <v-flex xs12>
                <h4 style="color: red">如果对密码进行了修改，请退出系统，使用修改后的密码重新登录！</h4>
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import mixin from '@/mixin'

const baseUri = '/api/syst/user';

export default {
  mixins: [mixin.edit(baseUri)],
  data() {
    return {
      formValid: false,

      item: {},
      freshItem: {
        "username": "",
        "password": "",
        "rePassword": "",
        "email": "",
        "phone": ""
      },

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。',
          v => (v && v.length <= 20) || '长度必须小于20个字符。'
        ],
        password: [
          v => !!v || '必填项。',
          // v => (v && v.length <= 20) || '长度必须小于20个字符。',
          v => (v && /^[^\s]+$/.test(v)) || '密码不能保含空格.',
          v => (v && /^(?![0-9]+$)(?![^0-9]+$)(?![a-zA-Z]+$)(?![^a-zA-Z]+$)(?![a-zA-Z0-9]+$)[a-zA-Z0-9\S]{8,30}$/.test(v)) || '密码强度不满足要求,密码要包含数字、字母和特殊字符，长度要求8位以上'
        ],
        rePassword: [
          v => !!v || '必填项。',
          v => (v && v.length <= 20) || '长度必须小于20个字符。',
          v => (v && this.item.password === v) || '两次输入的密码不一致.'
        ],
        email: [
          v => !!v || '必填项。',
          v => (!v || v.trim().length === 0 || /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ig.test(v)) || '邮箱格式不正确'
        ],
        phone: [
          v =>
            (
              v &&
              (/(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/.test(v))
            ) || '电话号码格式不正确，请输入正确的手机号码，或固定电话号码.'
        ]
      }
    }
  },

  methods: {
    // mixin 加载数据后调用
    afterGetData(data){
      this.item.password=''
    },
    beforeSendData(data) {
      Object.assign(data, this.item);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Edit.vue